import {useEffect, useState} from 'react'
import {Space, Table, Button, Alert, Modal, Popconfirm, Tag, Select, Tooltip} from 'antd'
import {DateComponent} from '../../../components/liste/dateComponent'
import {
  DeleteOutlined,
  DislikeOutlined,
  EditOutlined,
  LikeOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import {
  addProgramme,
  deleteProgramme,
  getListeProgramme,
  updateEtatProgramme,
  updateProgramme,
} from '../../../data/params/programme'
import {getListeAssertionActive} from '../../../data/params/assertion'

const ProgrammeDeTravail = () => {
  const [programmes, setProgrammes] = useState([])
  const [programme, setProgramme] = useState([])
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')
  const [libelle, setLibelle] = useState([''])
  const [reference, setReference] = useState('')
  const [codeSommaire, setCodeSommaire] = useState('')
  const [groupeSommaire, setGroupeCodeSommaire] = useState([])
  const [filteredItems, setFilteredItems] = useState([])
  const [group, setGroup] = useState('')
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [edite, setEdite] = useState(false)
  const [assertions, setAssertions] = useState([])
  const [assertionsSelected, setAssertionsSelected] = useState([])
  const arrayCodeSommaire = Array.from({length: 17}, (_, index) => `EE3.${1 + index}`)

  useEffect(() => {
    fetchAssertions()
  }, [])

  const handleChange = (value) => {
    setAssertionsSelected(value)
  }

  const fetchAssertions = async () => {
    try {
      const res = await getListeAssertionActive()
      if (res.result) {
        setAssertions(res.result)
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des événements risques', error)
    }
  }

  const columns = [
    {
      title: '#',
      render: (text, record, index) => (
        <span className='display-block chart-blue'>{index + 1}</span>
      ),
    },
    {
      title: 'reference',
      dataIndex: 'reference',
      key: 'reference',
      render: (text) => <span className='display-block bold'>{text}</span>,
    },
    {
      title: 'Libelle',
      dataIndex: 'libelle',
      key: 'libelle',
      render: (text, record) =>
        record.libelle?.length > 1
          ? record.libelle?.map((opt, indexOpt) => (
              <div key={indexOpt} className='d-flex flex-column'>
                <span className='' style={{fontSize: '12px'}}>
                  <strong className='me-2 fw-bolder' style={{fontSize: '15px'}}>
                    -
                  </strong>
                  {opt}
                </span>
              </div>
            ))
          : record.libelle?.length >= 0
          ? record.libelle?.map((opt, indexOpt) => (
              <span className='' key={indexOpt} style={{fontSize: '12px'}}>
                {opt}
              </span>
            ))
          : '',
    },
    // {
    //   title: 'codeSommaire',
    //   dataIndex: 'codeSommaire',
    //   key: 'codeSommaire',
    //   render: (text) => <span className='display-block bold'>{text}</span>,
    // },
    {
      title: 'Assertions',
      dataIndex: 'assertions',
      key: 'assertions',
      render: (_, record) => (
        <div className='d-flex align-center'>
          {record.assertions?.map((assertion, index) => (
            <span className='fw-bolder me-3' key={index}>
              {assertion}
            </span>
          ))}
        </div>
      ),
    },
    {
      title: 'Etat',
      dataIndex: 'etat',
      key: 'etat',
      render: (_, record, index) =>
        record.etat === 1 ? <Tag color='green'>Activé</Tag> : <Tag color='red'>Désactivé</Tag>,
    },
    {
      title: 'Créée le / Par',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record, index) => (
        <DateComponent
          date={record.createdAt}
          user={record.nom_user + ' ' + record.prenom_user}
          key={index}
        />
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record, index) => (
        <Space size='middle'>
          <Button
            type='primary'
            icon={<EditOutlined />}
            onClick={() => selectProgramme(record.id)}
          />

          {record.etat === 0 && (
            <Popconfirm
              title={`Activer la période ${record.libelle[index]} ?`}
              reference={`Voulez vous vraiment activer la période ${record.libelle[index]} ?`}
              onConfirm={() => handleUpdateEtatProgramme(record.id, 1)}
              okText='Oui'
              cancelText='Non'
            >
              <Button icon={<DislikeOutlined />} className='chart-bg-orange' title='Activer ?' />
            </Popconfirm>
          )}

          {record.etat === 1 && (
            <Popconfirm
              title={`Désactiver la période ${record.libelle[index]} ?`}
              reference={`Voulez vous vraiment désactiver la période ${record.libelle[index]} ?`}
              onConfirm={() => handleUpdateEtatProgramme(record.id, 0)}
              okText='Oui'
              cancelText='Non'
            >
              <Button icon={<LikeOutlined />} className='chart-bg-green' title='Désactiver ?' />
            </Popconfirm>
          )}

          <Popconfirm
            title={`Supprimer la période ${record.libelle[index]} ?`}
            reference={`Voulez vous vraiment supprimer la période ${record.libelle[index]} ?`}
            onConfirm={() => handleDeleteProgramme(record.id)}
            okText='Oui'
            cancelText='Non'
          >
            <Button title='Supprimer ?' type='primary' icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ]

  useEffect(() => {
    const libelleGroup = [...new Set(programmes.map((item) => item.codeSommaire))]
    setGroupeCodeSommaire(libelleGroup)
  }, [programmes])

  const handleFiltered = (search) => {
    const filteredItems = programmes.filter(
      (item) =>
        item?.libelle?.map((opt) => opt.toLowerCase().includes(search.toLowerCase())) ||
        item.reference.toLowerCase().includes(search.toLowerCase()) ||
        item.id === parseInt(search)
    )
    setFilteredItems(filteredItems)
  }

  const showModal = () => {
    setOpen(true)
  }

  const handleAddProgramme = async () => {
    setLoading(true)
    const data = {libelle, reference, assertions: assertionsSelected, codeSommaire}
    console.log(data)
    const {status, message} = await addProgramme(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle([])
      setReference('')
      setCodeSommaire('')
      setAssertionsSelected([])
      handleListeProgramme()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleModifierProgramme = async () => {
    setLoading(true)
    const data = {
      programme_id: programme.id,
      libelle,
      reference,
      codeSommaire,
      assertions: assertionsSelected,
    }
    console.log(data)
    const {status, message} = await updateProgramme(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle([])
      setReference('')
      setCodeSommaire('')
      setAssertionsSelected([])
      handleListeProgramme()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }


  const handleCancel = () => {
    setOpen(false)
    setEdite(false)
    setLibelle([])
    setReference('')
    setCodeSommaire('')
    setAssertionsSelected([])
    setError(false)
  }

  const selectProgramme = (programme_id) => {
    const privil = programmes.filter((periode) => periode.id === programme_id)[0]
    setProgramme(privil)
    setLibelle(privil.libelle)
    setReference(privil.reference)
    setCodeSommaire(privil.codeSommaire)
    setAssertionsSelected(privil.assertions)
    setEdite(true)
    setOpen(true)
  }

  const handleListeProgramme = async () => {
    setLoading(true)
    const {result, status, message} = await getListeProgramme()
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setProgrammes(result)
      setFilteredItems(result)
      handleCancel()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleDeleteProgramme = async (programme_id) => {
    setLoading(true)
    const data = {programme_id}
    const {status, message} = await deleteProgramme(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      handleListeProgramme()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleUpdateEtatProgramme = async (programme_id, etat) => {
    setLoading(true)
    const data = {programme_id, etat}
    const {status, message} = await updateEtatProgramme(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle([])
      setReference('')
      setCodeSommaire('')
      setAssertionsSelected([])
      handleListeProgramme()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  // const handleSearchDesCivilite = () => {
  //   const civs = Programmes.filter(civilite => civilite.id == )

  // }

  useEffect(() => {
    handleListeProgramme()
  }, [])

  const handleAddInput = (e) => {
    e.preventDefault()

    setLibelle([...libelle, ''])
  }

  const handleInputChange = (index, value) => {
    const updated = [...libelle]
    updated[index] = value
    setLibelle(updated)
  }

  const handleDeleteInputValue = (index, e) => {
    e.preventDefault()
    const updated = [...libelle]
    updated.splice(index, 1)
    setLibelle(updated)
  }

  return (
    <>
      <div className='card mb-5 mb-lg-10'>
        {error === true && (
          <Space
            direction='vertical'
            style={{
              width: '100%',
            }}
          >
            <Alert message='Error' reference={message} type='error' showIcon />
          </Space>
        )}

        <div className='card-header'>
          <div className='card-title'>
            <h3>Liste des programmes de travail</h3>
          </div>

          <div className='card-toolbar'>
            <div className='my-1 me-4'>
              <input
                type='text'
                name='fname'
                onChange={(e) => handleFiltered(e.target.value)}
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Rechercher'
              />
            </div>

            <div className='d-flex align-items-center'>
              <div className='fv-row fv-plugins-icon-container me-7'>
                <select
                  className='form-select mb-2 w-350px'
                  data-control='select2'
                  data-placeholder='Select an option'
                  name='payment_method'
                  data-select2-id='select2-data-kt_ecommerce_edit_order_payment'
                  tabIndex='-1'
                  onChange={(e) => {
                    const updateList = programmes.filter(
                      (item) => item.codeSommaire === e.target.value
                    )
                    if (updateList && updateList.length > 0) {
                      setFilteredItems(updateList)
                      setGroup(e.target.value)
                    } else {
                      setFilteredItems(programmes)
                      setGroup(null)
                    }
                  }}
                  value={group}
                >
                  <option data-select2-id='select2-data-11-txbs'>
                    Filtrer par le code du sommaire...
                  </option>
                  {groupeSommaire.map((item, index) => (
                    <option value={item} key={index} data-select2-id='select2-data-132-sp74'>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <Button type='primary' icon={<PlusOutlined />} onClick={showModal} size='large'>
              Ajouter
            </Button>
            {/* <a href="#" className="btn btn-sm btn-primary my-1">View All</a> */}
          </div>
        </div>

        <div className='card-body p-0'>
          <div className='table-responsive'>
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredItems}
              pagination={{current: 1, pageSize: 50}}
            />
          </div>
        </div>
      </div>

      <Modal
        open={open}
        title={!edite ? 'Enregistrer une nouvelle programme' : 'Modifier la programme'}
        onOk={!edite ? handleAddProgramme : handleModifierProgramme}
        onCancel={handleCancel}
        footer={[
          <Button key='back' onClick={handleCancel}>
            Annuler
          </Button>,
          <Button
            key='submit'
            type='primary'
            loading={loading}
            onClick={!edite ? handleAddProgramme : handleModifierProgramme}
          >
            Enregistrer
          </Button>,
        ]}
      >
        {error === true && (
          <Space
            direction='vertical'
            style={{
              width: '100%',
            }}
          >
            <Alert message={message} type='error' showIcon />
          </Space>
        )}
        <p>
          <label className='bold'>Code Sommaire</label>
          <select
            name='codeSommaire'
            className='form-select w-100 me-15'
            onChange={(e) => {
              setCodeSommaire(e.target.value)
            }}
            value={codeSommaire}
          >
            <option value=''>Selectionner un code...</option>
            {arrayCodeSommaire.map((libelle, index) => (
              <option key={index} value={libelle}>
                {libelle}
              </option>
            ))}
          </select>
        </p>
        <p>
          <label className='bold'>Reference</label>
          <input
            type='text'
            name='fname'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            onChange={(e) => setReference(e.target.value)}
            value={reference}
            placeholder='Entrez le libelle'
          />
        </p>
        <p>
          <label className='bold'>Libellé</label>
          <div className='d-flex justify-content-between'>
            <div className='col-lg-11 me-5'>
              <div className=' d-flex flex-column mb-2'>
                {libelle?.map((value, index) => (
                  <div className='d-flex align-items-center mb-2' key={index}>
                    <input
                      style={{fontSize: '12px'}}
                      className='form-control w-100 me-3'
                      type='text'
                      value={value}
                      name='procedure'
                      onChange={(e) => handleInputChange(index, e.target.value)}
                    />
                    <Tooltip title='supprimer un point de libellé'>
                      <Button
                        onClick={(e) => handleDeleteInputValue(index, e)}
                        title='Supprimer ?'
                        type='primary'
                        icon={<DeleteOutlined />}
                        danger
                      />
                    </Tooltip>
                  </div>
                ))}
              </div>
            </div>
            <div className='col-lg-1'>
              <Tooltip title='Ajouter un point de libellé'>
                <Button className='mb-2 ' onClick={(e) => handleAddInput(e)}>
                  <PlusOutlined style={{color: 'blue'}} />
                </Button>
              </Tooltip>
            </div>
          </div>
        </p>
        <p>
          <label className='bold'>Assertions</label>
          <Select
            mode='tags'
            style={{width: '100%'}}
            placeholder='choisir les assertions'
            onChange={handleChange}
            value={assertionsSelected}
            options={assertions.map((item) => ({
              label: item.libelle,
              value: item.libelle,
            }))}
          />
        </p>
      </Modal>
    </>
  )
}

export default ProgrammeDeTravail
